import React from 'react'
import './Bigin_day_modal.css'
import { Modal, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const Bigin_day_modal = ({ image, ...props }) => {

    // const handleDownload = () => {
    //     console.log("called");
    //     const link = document.createElement("a");
    //     link.href = image;
    //     link.download = "quote.png";
    //     link.click();
    // };

    const handleDownload = async () => {
        try {
            const response = await fetch(image);

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = "spiritual_insight.jpg";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Image download failed:", err);
        }
    };


    const handleShare = async () => {
        try {
            const response = await fetch(image, { mode: "cors" });
            const blob = await response.blob();
            const file = new File([blob], "quote.png", { type: "image/png" });

            if (navigator.canShare && navigator.canShare({ files: [file] })) {
                await navigator.share({
                    files: [file],
                    title: "Quote of the Day",
                    text: "Check out this quote!",
                });
            } else {
                alert("Sharing images is not supported on this device or browser.");
            }
        } catch (err) {
            console.error("Error sharing image:", err);
        }
    };

    return (
        <>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="Bigin_day_modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='quotediv'>
                        <img className='quoteimg' src={image} alt='Spiritual Insight' />
                        {/* <img className='quoteimg' src={process.env.PUBLIC_URL + '/assets/images/home/quote-day/quotes.png'} /> */}
                    </div>

                    <div className='signdwndiv'>
                        <div className='dnldflex'>
                            <img className='icon' src={process.env.PUBLIC_URL + '/assets/images/home/quote-day/download.png'} onClick={handleDownload} />
                            <img className='icon' src={process.env.PUBLIC_URL + '/assets/images/home/quote-day/share.png'} onClick={handleShare} />
                        </div>

                        <img className='signimg' src={process.env.PUBLIC_URL + '/assets/images/home/quote-day/sign.png'} />
                    </div>

                    <div className='viewspritualdiv'>
                        <Link to={"/all-quotes"}>
                            <button className='viewbtn zoom_in_out'>View Spiritual Insights</button>
                        </Link>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )
}

export default Bigin_day_modal